import _ from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";
import { ModalDialog, Modal } from "react-bootstrap";
// import TemplateEditor from "./grape";
import Button from "react-bootstrap-button-loader";
import renderHTML from "react-render-html";
import LocaleStrings from "Languages";

class LogContent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
    };
  }

  render() {
    let { data, emailLogContentReducers } = this.props;

    var mainDivStyle = {
      height: data.content != null ? `` : `100vh`,
      // left: leftPosition == 0 ? `0px` : `${195}px`,
    };
    if (emailLogContentReducers && emailLogContentReducers.data !== null) {
      var contentData = emailLogContentReducers.data.replaceAll("<a", "<span");
      var userContent = contentData.replaceAll("</a>", "</span>");
    }
    return (
      // <ModalDialog dialogClassName="my-modal ">
      <Modal
        show={this.props.isOpen}
        onHide={this.props.onClose}
        className="modal-container emaillog"
      >
        <Modal.Header >
          <Modal.Title><div className="title-modal">{LocaleStrings.content_modal_EmailLog}</div></Modal.Title>
          <button
            type="button"
            className="i-custom-cross-popup pull-right"
            onClick={this.props.onClose}
          // style={{textAlign:'end'}}
          >
            <img
              className="i-custom-small"
              src="../../style/images/custom-icons/cross-black.png"
            />
          </button>
        </Modal.Header>
        {/* <Modal.Body style={mainDivStyle}> */}
        <Modal.Body style={{ height: "100%", overflowY: "auto" }}>
          {/* renderHtml({data.content}) */}
          {emailLogContentReducers.data != null ? (
            <div>
              {userContent !== undefined && userContent !== null
                ? renderHTML(userContent)
                : null}
            </div>
          ) : (
            <div className="mt-20">{LocaleStrings.no_content_EmailLog}</div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={this.props.onClose}>
            {LocaleStrings.button_close}
          </Button>
        </Modal.Footer>
      </Modal>
      // </ModalDialog>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    session: state.session,
    data: ownProps.data,
    emailLogContentReducers: state.emailLogContentReducers,
  };
}

export default connect(mapStateToProps)(LogContent);
